import { database } from '../../firebase';
import { ref, get, remove, update } from 'firebase/database';

export const getWishlistEntries = async () => {
  try {
    const wishlistRef = ref(database, 'wishlist');
    const snapshot = await get(wishlistRef);
    
    if (snapshot.exists()) {
      const entries = [];
      snapshot.forEach((childSnapshot) => {
        entries.push({
          id: childSnapshot.key,
          ...childSnapshot.val()
        });
      });
      
      // Sort by most recent first
      return entries.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });
    }
    return [];
  } catch (error) {
    console.error('Error fetching wishlist entries:', error);
    throw error;
  }
};

export const deleteWishlistEntry = async (entryId) => {
  try {
    const entryRef = ref(database, `wishlist/${entryId}`);
    await remove(entryRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting wishlist entry:', error);
    return { 
      success: false,
      error: error.message
    };
  }
};

export const updateWishlistEntry = async (entryId, updates) => {
  try {
    const entryRef = ref(database, `wishlist/${entryId}`);
    await update(entryRef, updates);
    return { success: true };
  } catch (error) {
    console.error('Error updating wishlist entry:', error);
    return { 
      success: false,
      error: error.message
    };
  }
}; 